module.exports = __webpack_public_path__ + "static/6-edda4ad13d0688670d0227964a684d0c.jpg";